export default [
  {
    path: '/',
    name: 'liveList',
    component: () => import('@/views/broadcast/liveHome.vue')
  },
  {
    path: '/:id',
    name: 'liveView',
    redirect: to => ({
      name: window.innerWidth >= 769 ? 'liveViewPc' : 'liveViewH5',
      params: to.params,
      query: to.query
    })
  },
  {
    path: '/:id/pc',
    name: 'liveViewPc',
    component: () => import('@/views/broadcast/liveViewPc.vue')
  },
  {
    path: '/:id/h5',
    name: 'liveViewH5',
    component: () => import('@/views/broadcast/liveViewH5.vue')
  }
]



// WEBPACK FOOTER //
// ./src/router/routers.js